"use client"

import Script from "next/script"
import { useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"

export function UmamiPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '')
    if (window.umami) {
      window.umami.track((props: any) => ({
        ...props,
        url,
      }))
    }
  }, [pathname, searchParams])

  return null
}

export function UmamiAnalytics() {
  return (
    <Script
      src="https://cloud.umami.is/script.js"
      data-website-id="0405ec8c-dbd6-4ee1-831d-2e5fe21af263"  
      data-auto-track="false"
      strategy="afterInteractive"
      defer
    />
  )
}